import { render } from "./LoadListPage.vue?vue&type=template&id=f1fd3e8a&scoped=true"
import script from "./LoadListPage.vue?vue&type=script&lang=js"
export * from "./LoadListPage.vue?vue&type=script&lang=js"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1fd3e8a"]])

export default __exports__